/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IRListItem } from '@rhybus/api'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { CREATE_INQUIRY, PROFILE } from '../../Configuration'
import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { COMPONENTS, COMPONENTS_CODE } from '../../assets/ts/data/common-metadata'
import { PascodeMetadata } from '../../assets/ts/data/pascode-metadata'
import { getMAJCOMCode, isChangeDetected } from '../../assets/ts/general/general'
import {
  isDODValid,
  isDropDownValid,
  isEmailValid,
  isInputValid,
  isMatch,
  isPhoneNumberValid,
  validateUniqueDoDID,
} from '../../assets/ts/validations/validations'
import Alert from '../../components/alert/alert'
import UserProfileRedirect from '../../components/alert/user-profile-redirect'
import Buttons from '../../components/buttons/buttons'
import ProfileValidationMsgs from '../../components/form-validation-msgs/profile-validation-msgs'
import usePascodeMetadata from '../../hooks/use-pascode-metadata'
import useUserProfile from '../../hooks/use-user-profile'
import PageHeader from '../../layouts/header/page-header'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { UserContext } from '../../store/user-context-provider'
import './profile.css'
import ProfileDetails from './profile-details'
import ProfileOrganizationDetails from './profile-organization-details'

const initialPASCODECheck = {
  HasLocation: false,
  HasOrganization: false,
  HasPASCODE: 'Yes',
}
const initialUserInput = {
  AssignedComponentCode: -1,
  DoDNumber: '',
  DutyEmail: '',
  DutyPhone: '',
  Installation: '',
  OrgMAJCOM: '',
  Organization: '',
  PASCODE: '',
  PASCODEServicedBy: '',
  PascodeID: -1,
  PersonalEmail: '',
  PersonalPhone: '',
  PersonalPhoneProvider: '',
  ProfileStatus: '',
  Rank: '',
  ServicingMAJCOM: '',
  ServicingOrganization: '',
  UserDisplayName: '',
  UserRID: '',
}
const LIST_NAME = 'UserProfileList'
const COLUMN_NAME = {
  AssignedComponentCode: 'AssignedComponentCode',
  DoDNumber: 'DoDNumber',
  DutyEmail: 'DutyEmail',
  DutyPhone: 'DutyPhone',
  EKey: 'eKey',
  ETag: 'eTag',
  Installation: 'Installation',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  OrgMAJCOM: 'OrgMAJCOM',
  Organization: 'Organization',
  PASCODE: 'PASCODE',
  PASCODEServicedBy: 'PASCODEServicedBy',
  PersonalEmail: 'PersonalEmail',
  PersonalPhone: 'PersonalPhone',
  PersonalPhoneProvider: 'PersonalPhoneProvider',
  ProfileStatus: 'ProfileStatus',
  Rank: 'Rank',
  ServicingMAJCOM: 'ServicingMAJCOM',
  ServicingOrganization: 'ServicingOrganization',
  UserDisplayName: 'UserDisplayName',
  UserRID: 'UserRID',
}

const initialValidationField = {
  DoDNumber: false,
  ProfileStatus: false,
  Rank: false,
  /* eslint-disable-next-line perfectionist/sort-objects */
  DutyEmail: false,
  DutyPhone: false,
  PersonalPhone: false,
  /* eslint-disable-next-line perfectionist/sort-objects */
  PersonalEmail: false,
  /* eslint-disable-next-line perfectionist/sort-objects */
  Installation: false,
  Organization: false,
  PASCODE: false,
}

const Profile = () => {
  const { pascodeMetadata } = usePascodeMetadata({
    IsArchived: false,
  })
  const { me, setUserProfile } = useContext(UserContext)
  const { userProfile } = useUserProfile({
    userRID: me?.rid,
  })
  const { currentPage, setCurrentPage, setPreviousPage } = useContext(PreviousPageContext)
  const { components, majcoms } = useContext(MetadataContext)
  const navigate = useNavigate()

  const [userInputs, setUserInputs] = useState(initialUserInput)
  const [pascodeChecks, setPascodeChecks] = useState(initialPASCODECheck)
  const [existingUser, setExistingUser] = useState({
    AssignedComponentCode: -1,
    eKey: '',
    eTag: '',
  })
  const [matchError, setMatchError] = useState({
    Installation: true,
    Organization: true,
    PASCODE: true,
  })
  const [uniqueChange, setUniqueChange] = useState<string>('')
  const [showCreateNewPopup, setShowCreateNewPopup] = useState(false)
  const { isCPOwner, isCustomer, isSiteAdmin, servincingComponent } = useContext(RoleContext)

  const [showReadonlyInput, setShowReadonlyInput] = useState(false)
  const [BtnTitle, setBtnTitle] = useState('')
  const [showRedirect, setShowRedirect] = useState(false)
  const [changeDetected, setChangeDetected] = useState(true)
  const [isValid, setIsValid] = useState(initialValidationField)
  const [pascodeDDL, setPascodeDDL] = useState<string[]>([])
  const [organizationPASCODE, setOrganizationPASCODE] = useState<PascodeMetadata[]>()
  const [isRegAF, setIsRegAF] = useState(true)
  const [assignedLocationDDL, setAssignedLocationDDL] = useState<string[]>([])
  const [organizationDDL, setOrganizationDDL] = useState<string[]>([])
  const [crossComponentAlert, setCrossComponentAlert] = useState(false)

  const [displayErrorPopUp, setDisplayErrorPopUp] = useState({
    Bottom: false,
    Top: false,
  })

  const closeRef: any = null
  function buttonReferences(type: any) {
    if (type !== 'close') {
      closeRef?.current?.closeBtn()
    }
  }
  const inputRefs = {
    DutyPhone: useRef(null),
    Installation: useRef(null),
    Organization: useRef(null),
    PASCODE: useRef(null),
    PersonalEmail: useRef(null),
    PersonalPhone: useRef(null),
    ProfileStatus: useRef(null),
    Rank: useRef(null),
  }
  const onChangeAssignedComponent = (e: any) => {
    const selectedComp = e.label.replace(/ /g, '')
    if (COMPONENTS[selectedComp].value === existingUser.AssignedComponentCode) {
      setUserInputs({ ...initialUserInput, ...existingUser })
      setShowReadonlyInput(true)
      setPascodeChecks({
        HasLocation: true,
        HasOrganization: true,
        HasPASCODE: 'Yes',
      })
    } else {
      setUserInputs({
        ...userInputs,
        AssignedComponentCode: COMPONENTS[selectedComp].value,
        Installation: '',
        OrgMAJCOM: '',
        Organization: '',
        PASCODE: '',
        PASCODEServicedBy: '',
        PascodeID: -1,
        ProfileStatus: 'Select',
        Rank: 'Select',
        ServicingMAJCOM: '',
        ServicingOrganization: '',
      })
      setPascodeChecks(initialPASCODECheck)
      setMatchError({ ...matchError, PASCODE: true })
      setShowReadonlyInput(false)
    }
  }

  const createProfile = async () => {
    const userProfileObj = {
      AssignedComponentCode: userInputs.AssignedComponentCode,
      DoDNumber: userInputs.DoDNumber,
      DutyEmail: userInputs.DutyEmail,
      DutyPhone: userInputs.DutyPhone,
      IsArchived: false,
      ItemCreated: new Date(),
      ItemCreatedBy: me.rid,
      ItemModified: new Date(),
      ItemModifiedBy: me.rid,
      PascodeID: userInputs.PascodeID,
      PersonalEmail: userInputs.PersonalEmail,
      PersonalPhone: userInputs.PersonalPhone,
      PersonalPhoneProvider: userInputs.PersonalPhoneProvider,
      ProfileStatus: userInputs.ProfileStatus,
      Rank: userInputs.Rank,
      UserDisplayName: userInputs.UserDisplayName,
      UserRID: me.rid,
    }
    if (existingUser.eKey !== '') userProfileObj['eKey'] = existingUser.eKey
    if (existingUser.eTag !== '') userProfileObj['eTag'] = existingUser.eTag
    if (me.email !== userInputs.DutyEmail) {
      userProfileObj['DutyEmail'] = me.email
      setUserInputs({ ...userInputs, DutyEmail: me.email })
    }
    try {
      const annList = await mpfRListsHttp().getList(LIST_NAME)
      const successful = await annList.addOrUpdateItem(userProfileObj as IRListItem)

      if (successful !== undefined) {
        setExistingUser({
          ...userInputs,
          eKey: successful?.eKey || '',
          eTag: successful?.eTag || '',
        })
        setShowRedirect(true)
      }
    } catch (error) {
      console.error(error)
    }
    setUniqueChange('')
  }

  function isRoleComponentMatches(workingComponent: string): boolean {
    if (isCustomer || isCPOwner || isSiteAdmin || servincingComponent === workingComponent) {
      return true
    } else {
      setCrossComponentAlert(true)
      return false
    }
  }

  const validate = async (position) => {
    setIsValid(initialValidationField)

    const bottomPosition = position === 'Bottom'
    if (isChangeDetected(existingUser, userInputs)) {
      setChangeDetected(true)
      let isAllValid = false

      const isValidDoDID = isDODValid(userInputs.DoDNumber)
      const isValidDutyEmail = isEmailValid(userInputs.DutyEmail)
      const isValidStatus = isDropDownValid(userInputs.ProfileStatus)
      const isValidRank = isDropDownValid(userInputs.Rank)
      const isValidDutyPhone = isPhoneNumberValid(userInputs.DutyPhone)
      const isValidInstallation =
        pascodeChecks.HasPASCODE === 'No' ? pascodeChecks.HasLocation : true
      const isValidOrganization =
        pascodeChecks.HasPASCODE === 'No' && pascodeChecks.HasLocation
          ? pascodeChecks.HasOrganization
          : true
      const isValidPersonalPhoneNumber = userInputs.PersonalPhone
        ? isPhoneNumberValid(userInputs.PersonalPhone)
        : true
      const isValidPersonalEmail = userInputs.PersonalEmail
        ? isEmailValid(userInputs.PersonalEmail)
        : true
      const isUniqueDoDID = !isValidDoDID
        ? true
        : await validateUniqueDoDID(
            userInputs.DoDNumber,
            userInputs.UserRID,
            LIST_NAME,
            COLUMN_NAME.UserRID,
            COLUMN_NAME.DoDNumber
          )
      const isValidPASCODE =
        pascodeChecks.HasPASCODE === 'Yes'
          ? isInputValid(userInputs.PASCODE) &&
            isMatch(pascodeDDL, userInputs.PASCODE) &&
            userInputs.PASCODE.length === 8
          : true

      setIsValid({
        ...isValid,
        DoDNumber: isValidDoDID && isUniqueDoDID,
        DutyEmail: isValidDutyEmail,
        DutyPhone: isValidDutyPhone,
        Installation: isValidInstallation,
        Organization: isValidOrganization,
        PASCODE: isValidPASCODE,
        PersonalEmail: isValidPersonalEmail,
        PersonalPhone: isValidPersonalPhoneNumber,
        ProfileStatus: isValidStatus,
        Rank: isValidRank,
      })

      isAllValid =
        isValidDoDID &&
        isValidPersonalPhoneNumber &&
        isUniqueDoDID &&
        isValidDutyEmail &&
        isValidDutyPhone &&
        isValidInstallation &&
        isValidOrganization &&
        isValidPASCODE &&
        isValidRank &&
        isValidPersonalEmail &&
        isValidStatus
      const assignedComponent: string =
        components.find((item) => item.ComponentCode === userInputs.AssignedComponentCode)
          ?.Component ?? ''
      if (isAllValid === true) {
        if (isRoleComponentMatches(assignedComponent)) {
          createProfile()
        }
      } else {
        setDisplayErrorPopUp({
          Bottom: bottomPosition,
          Top: !bottomPosition,
        })
      }
    } else {
      setDisplayErrorPopUp({
        Bottom: bottomPosition,
        Top: !bottomPosition,
      })
      setChangeDetected(false)
    }
  }

  const checkIfUserHasProfile = async () => {
    if (userProfile?.length === 1) {
      const i = userProfile[0]
      const userProfileObj = {
        AssignedComponentCode: i.AssignedComponentCode || -1,
        DoDNumber: i.DoDNumber,
        DutyEmail: i.DutyEmail || '',
        DutyPhone: i.DutyPhone || '',
        Installation: i.Installation || '',
        OrgMAJCOM: i.OrgMAJCOM || '',
        Organization: i.Organization || '',
        PASCODE: i.PASCODE || '',
        PASCODEServicedBy: i.PASCODEServicedBy || '',
        PascodeID: i.PascodeID || -1,
        PersonalEmail: i.PersonalEmail || '',
        PersonalPhone: i.PersonalPhone || '',
        PersonalPhoneProvider: i.PersonalPhoneProvider || '',
        ProfileStatus: i.ProfileStatus || '',
        Rank: i.Rank || '',
        ServicingMAJCOM: i.ServicingMAJCOM || '',
        ServicingMAJCOMCode: getMAJCOMCode(i.ServicingMAJCOM, majcoms),
        ServicingOrganization: i.ServicingOrganization || '',
        UserDisplayName: i.UserDisplayName || '',
        UserRID: i.UserRID,
        eKey: i.eKey,
        eTag: i.eTag,
      }
      setUserInputs({ ...initialUserInput, ...userProfileObj })
      setPascodeChecks({
        HasLocation: true,
        HasOrganization: true,
        HasPASCODE: 'Yes',
      })
      setExistingUser(userProfileObj)
      setShowReadonlyInput(true)
      return userProfileObj
    }
  }
  const handleRouteYes = () => {
    navigate(CREATE_INQUIRY, {
      state: { prevPath: PROFILE },
    })
    setUserProfile([userInputs])
  }

  const handleRouteNo = () => {
    setShowRedirect(false)
    setUserProfile([userInputs])
    navigate(`${PROFILE}`)
  }

  useEffect(() => {
    setUserInputs({
      ...userInputs,
      AssignedComponentCode: COMPONENTS.RegularAirForce.value,
      DoDNumber: me?.edipi,
      DutyEmail: me?.email,
      UserDisplayName: me?.persona,
      UserRID: me?.rid,
    })
  }, [me])
  useEffect(() => {
    const requestUserProfile = async () => {
      document.title = 'Profile' // sets the page title in the browser tab
      const hasProfile = await checkIfUserHasProfile()
      if (hasProfile) {
        const isEmailChanged = userProfile[0].DutyEmail !== me?.email
        isEmailChanged && setUniqueChange('Duty Email has recently changed.')
        setShowCreateNewPopup(isEmailChanged)
        setBtnTitle('Update')
       } else setBtnTitle('Submit')

      !hasProfile && navigate(`${PROFILE}`) // keep url set to /profile if user hasn't created one
    }
    me && userProfile ? requestUserProfile() : ''
  }, [me, userProfile, navigate])

  const handleFocus = (field: string) => {
    const ref = inputRefs[field]
    if (ref && ref.current) {
      ref.current.focus()
    }
  }

  useEffect(() => {
    const orgPASCODE = pascodeMetadata.filter(
      (item) =>
        userInputs?.AssignedComponentCode === -1 ||
        item.AssignedComponentCode === userInputs?.AssignedComponentCode
    )
    if (userInputs?.AssignedComponentCode === COMPONENTS_CODE.Regular_Air_Force) {
      setIsRegAF(true)
    } else {
      setIsRegAF(false)
    }
    setOrganizationPASCODE(orgPASCODE)
  }, [pascodeMetadata, userInputs?.AssignedComponentCode])

  useEffect(() => {
    const assignedlocations = organizationPASCODE
      ? [
          ...new Set(
            organizationPASCODE.map(({ Installation }) => {
              return Installation
            })
          ),
        ].filter((item) => item !== undefined)
      : []
    const organizations = organizationPASCODE
      ? [
          ...new Set(
            organizationPASCODE.map(({ Organization }) => {
              return Organization
            })
          ),
        ].filter((item) => item !== undefined)
      : []
    const pascodes = organizationPASCODE
      ? [
          ...new Set(
            organizationPASCODE.map(({ PASCODE }) => {
              return PASCODE
            })
          ),
        ].filter((item) => item !== undefined)
      : []
    setAssignedLocationDDL(assignedlocations)
    setOrganizationDDL(organizations)
    setPascodeDDL(pascodes)
  }, [organizationPASCODE])

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes

  return (
    <>
      <PageHeader icon='icon-user font-14 me-1 color-primary' name='My Profile' />
      <div className='container'>
        <div className='row'>
          <div className='col-sm-12 col-lg'>
            <div className='whitebg border-radius'>
              <div className='d-flex w-100 p-relative flex-wrap align-items-center profileheader justify-content-between py-3'>
                <div className='px-3'>
                  <h2
                    aria-label='Instructions'
                    className='latobold font-13 title-color2 text-uppercase py-1 m-0 px-0 d-inline-block'
                    tabIndex={0}
                  >
                    Instructions
                  </h2>
                  <ul className='mx-0 my-1 p-0 d-flex flex-wrap list-type-none'>
                    <li
                      aria-label='All fields marked ‘*’ must be completed.'
                      className='pe-3 title-color16 sourcesanspro font-13 me-1'
                      tabIndex={0}
                    >
                      <span className='spancircle'></span>All fields marked
                      <span className='mandatory'>‘*’</span> must be completed.
                    </li>
                    <li
                      aria-label=' Use ‘Update’ button to Update your Profile.'
                      className='pe-3 title-color16 sourcesanspro font-13 me-1'
                      tabIndex={0}
                    >
                      <span className='spancircle'></span> Use ‘Update’ button to Update your
                      Profile.
                    </li>
                  </ul>
                </div>
                <div className='ms-auto mx-3'>
                  <Buttons
                    aria-label='Update'
                    className='btn-border btn-lg btn-primary whitetext font-0 font-md-13 poppins-medium btn-border-radius3 p-relative text-uppercase profileupdatbutton'
                    icon='icon-update1 font-13 me-md-1 bold'
                    label='Update'
                    onClick={() => {
                      validate('Top')
                    }}
                  />
                </div>
              </div>
              <div className='px-3'>
                {displayErrorPopUp.Top && (
                  <div>
                    <ProfileValidationMsgs
                      changeDetected={changeDetected}
                      displayErrorPopUp={displayErrorPopUp}
                      onClick={handleFocus}
                      ref={closeRef}
                      setDisplayErrorPopUp={setDisplayErrorPopUp}
                      updateClickPosition='Top'
                      validationField={isValid}
                    />
                  </div>
                )}
              </div>

              <div className='detailsinfo'>
                <ProfileDetails
                  inputRefs={inputRefs}
                  onChangeAssignedComponent={onChangeAssignedComponent}
                  setUserInputs={setUserInputs}
                  userInputs={userInputs}
                />
                <ProfileOrganizationDetails
                  assignedLocationDDL={assignedLocationDDL}
                  existingUser={existingUser}
                  inputRefs={inputRefs}
                  isProfilePage={true}
                  isRegAF={isRegAF}
                  majcoms={majcoms}
                  matchError={matchError}
                  organizationDDL={organizationDDL}
                  organizationPASCODE={organizationPASCODE}
                  pascodeChecks={pascodeChecks}
                  pascodeDDL={pascodeDDL}
                  pascodeMetadata={pascodeMetadata}
                  setMatchError={setMatchError}
                  setOrganizationDDL={setOrganizationDDL}
                  setPascodeChecks={setPascodeChecks}
                  setShowReadonlyInput={setShowReadonlyInput}
                  setUserInputs={setUserInputs}
                  showReadonlyInput={showReadonlyInput}
                  userInputs={userInputs}
                />
                {showRedirect && (
                  <UserProfileRedirect
                    handleRouteNo={handleRouteNo}
                    handleRouteYes={handleRouteYes}
                  />
                )}
                {crossComponentAlert && (
                  <Alert
                    alerttextclass='poppins-semibold font-13 text-center'
                    btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
                    btn1iconclassNmae='icon-checked font-12 pe-1'
                    className='alert-info'
                    message={
                      "The selected user's profile component and working component are different. Please update profile to working component."
                    }
                    onClick={() => setCrossComponentAlert(false)}
                    yes='OK'
                  />
                )}
                {showCreateNewPopup && (
                  <Alert
                    alerttextclass='poppins-semibold font-13 text-center'
                    btn1className='btn btn btn-sm font-12 poppins-semibold btn-primary whitetext border-radius text-uppercase'
                    btn1iconclassNmae='icon-checked font-12 pe-1'
                    cancel='No'
                    className='alert-info'
                    handleRouteNo={() => handleRouteNo()}
                    handleRouteYes={() => createProfile()}
                    message={`${uniqueChange} Do you want to update profile details?`}
                    setShowAlert={setShowCreateNewPopup}
                    yes='OK'
                  />
                )}
                <div className='px-3'>
                  {displayErrorPopUp.Bottom && (
                    <div>
                      <ProfileValidationMsgs
                        changeDetected={changeDetected}
                        displayErrorPopUp={displayErrorPopUp}
                        onClick={handleFocus}
                        ref={closeRef}
                        setDisplayErrorPopUp={setDisplayErrorPopUp}
                        updateClickPosition='Bottom'
                        validationField={isValid}
                      />
                    </div>
                  )}
                </div>
                <div className='d-flex w-100 position-relative flex-wrap align-items-center profileheader justify-content-between py-3'>
                  <div className='ms-auto mx-3'>
                    <Buttons
                      aria-label='Update'
                      className='btn-border btn-lg btn-primary whitetext font-0 font-md-13 poppins-medium btn-border-radius3 p-relative text-uppercase'
                      icon='icon-update1 font-13 me-md-1 bold'
                      label='Update'
                      onClick={() => {
                        validate('Bottom')
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Profile
